import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  translatingLoaderText: {
    id: 'unit-translation-selector-plugin.translationsLoader.loaderText',
    defaultMessage: 'Translating',
    description: 'Translating text shown when translating to a language',
  },
});

export default messages;
